import { IntlShape } from "react-intl";
import moment from "moment";
import { isRu } from "services/region/region";
import { LocalDate, PeriodUnit } from "types/general";

export enum Month {
  JANUARY,
  FEBRUARY,
  MARCH,
  APRIL,
  MAY,
  JUNE,
  JULY,
  AUGUST,
  SEPTEMBER,
  OCTOBER,
  NOVEMBER,
  DECEMBER,
}

export type Duration = {
  duration: number,
  durationUnit: PeriodUnit
}

export class DateUtils {

  static getFormatDate(date?: LocalDate) {
    if (!date) {
      return "-";
    }
    if (isRu()) {
      const monthIndex = Month[date.month as unknown as keyof typeof Month];
      return moment(new Date(date.year, monthIndex, date.dayOfMonth)).format("D MMM YYYY");
    }
    return `${date.dayOfMonth} ${this.getShortName(date.month)} ${date.year}`;
  }

  static getDate(date?: Date) {
    if (!date) {
      return "-";
    }
    if (isRu()) {
      return moment(date).format("D MMM YYYY");
    }
    return `${date.getDay()} ${this.getShortName(date.getMonth())} ${date.getFullYear()}`;
  }

  static getShortName(mouth: Month) {
    const mouthString = mouth.toString();
    return mouthString.charAt(0) + mouthString.slice(1, 3).toLowerCase();
  }

  static getFormatDuration(dur: Duration, intl: IntlShape) {
    const { durationUnit, duration } = dur;
    return intl.formatMessage(
      { id: `jmix-store.duration-count.${durationUnit}` },
      { count: duration },
    );
  }

  static getFormatTime(value: number) {
    const min = Math.floor(value / 60);
    const sec = value % 60;

    return `${min}:${sec}`;
  }
}